// errors.ts
var APIError = class extends Error {
  method;
  url;
  status;
  constructor(request, response, error) {
    const status = response?.status || -1;
    const trailer = `(method=${request.method}, url=${request.url}, status=${status})`;
    if (error) {
      if (typeof error === "string") {
        super(`API Error: ${error} ${trailer}`);
      } else if (typeof error === "object") {
        if (error.message) {
          super(`API Error: ${error.message} ${trailer}`);
        } else {
          super(`API Error ${trailer}`);
        }
        if (error instanceof Error && error.stack) {
          this.stack = `APIError: ${this.message}
  ${error.stack}`;
        }
        Object.entries(error).forEach(([key, value]) => {
          if (["message", "stack", "status", "url", "method"].indexOf(key) < 0) {
            Object.defineProperty(this, key, { enumerable: true, value });
          }
        });
      } else {
        super(`API Error ${trailer}`);
      }
    } else {
      super(`API Error ${trailer}`);
    }
    try {
      this.name = "APIError";
    } catch {
    }
    this.method = request.method;
    this.url = request.url;
    this.status = status;
  }
};
export {
  APIError
};
//# sourceMappingURL=errors.mjs.map
